
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src2984367493/src/vl-app/pages/clinician/timeline360.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useInitialisedStore } from '@hooks/useInitialisedStore';
import AuditTimeLine from 'vl-common/src/components/TimeLine/ReferrerViewTimeLine';
import { useRouter } from 'next/router';
import Header from '@components/Layouts/Header/Header';

const ClinicianTimelineWrapper = () => {
  const { t } = useTranslation('common');
  const initialised = useInitialisedStore();
  const router = useRouter();

  if (!initialised) {
    return <p>{t('Initialising ...')}</p>;
  }

  return (
    <>
      <Header pageType="clinician" pageTitle="Timeline" />

      <section className="section-layout">
        <div className="vl-common-timeline-bootstrap-overrides ">
          <div className="vl-common-bootstrap vl-appLayout">
            <AuditTimeLine history={{ goBack: router.back }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default ClinicianTimelineWrapper;
export const Route = createFileRoute('/clinician/timeline360')({ component: ClinicianTimelineWrapper });
